import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
} from 'formik';
import * as yup from 'yup';
import {
  Row,
  Col,
  ControlLabel,
  FormGroup,
  FormControl,
  Checkbox,
  Alert,
  Button,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import { withTranslation } from 'react-i18next';

class ProductForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
    };
    this.anchor = React.createRef();
  }

  componentDidMount () {
    this.anchor.current.scrollIntoView();
  }

  isOnlineProduct = () => {
    const { selectedExtraId, getOnlineExtraById } = this.props.mixStore;
    return !!getOnlineExtraById(selectedExtraId);
  };

  getInitialValues() {
    return {
      itemCode: '',
      itemDescription: '',
      unitCode: '',
      unitSymbol: '',
      taxable: false,
    };
  }

  render() {
    const { mixStore, materialStore, onCancel, t } = this.props;
    const { addExtra, selectedExtraId, getExtraById, getOnlineExtraById, updateExtra } = mixStore;
    const units = materialStore.unit || [];

    const getUnitSymbolByCode = (unitCode) => {
      const unit = units.find(v => v.code === unitCode);
      return unit ? unit.symbol || unit.name : '';
    };

    return !units.length ? '' : (
      <div ref={this.anchor}>
        <Formik
          enableReinitialize
          initialValues={
            !selectedExtraId
              ? this.getInitialValues()
              : getExtraById(selectedExtraId) || getOnlineExtraById(selectedExtraId) || this.getInitialValues()
          }
          validationSchema={yup.object().shape({
            itemCode: yup.string().required('Required!'),
            unitCode: yup.string().required('Required!'),
          })}
          onSubmit={(values, actions) => {
            this.setState({
              error: null,
            });
            let promise;
            if (this.isOnlineProduct()) {
              promise = updateExtra(values);
            } else {
              promise = addExtra(values);
            }

            promise
              .then(() => {
                actions.setSubmitting(false);
              })
              .catch((e) => {
                this.setState({
                  error: `Couldn't save: ${e.message}`,
                });
                actions.setValues(values);
                actions.setSubmitting(false);
              });

          }
          }
        >{({ handleChange,
            values,
            setValues,
            errors,
            touched,
            isSubmitting,
          }) => (
            <Form className={'extra-product-form'}>
              <Row>
                <Col md={3} sm={6} xs={6}>
                  <FormGroup className={errors.itemCode && touched.itemCode? 'has-error' : ''}>
                    <ControlLabel>{t('Code')}</ControlLabel>
                    <Field name="itemCode"
                      placeholder={t('Code')}
                      disabled={this.isOnlineProduct()}
                      value={values.itemCode || ''}
                      className="form-control input-sm" />
                    <ErrorMessage component="span" name="itemCode" className="help-block" />
                  </FormGroup>
                </Col>
                <Col md={3} sm={6} xs={6}>
                  <FormGroup>
                    <ControlLabel>{t('Description')}</ControlLabel>
                    <Field name="itemDescription"
                      placeholder={t('Description')}
                      disabled={this.isOnlineProduct()}
                      value={values.itemDescription || ''}
                      className="form-control input-sm" />
                  </FormGroup>
                </Col>
                <Col md={3} sm={6} xs={6}>
                  <FormGroup className={errors.unitCode && touched.unitCode? 'has-error' : ''}>
                    <ControlLabel>{t('Unit')}</ControlLabel>
                    <FormControl
                      name="unitCode"
                      componentClass="select"
                      disabled={this.isOnlineProduct()}
                      value={values.unitCode || ''}
                      onChange={e => {
                        const unitCode = e.target.value;
                        setValues({ ...values, unitCode, unitSymbol: getUnitSymbolByCode(unitCode)});
                      }}
                      bsSize="sm"
                    >
                      <option value=""/>
                      {units.map(option => (
                        <option key={option.id} value={option.code}>
                          {option.symbol || option.name} {option.description}
                        </option>
                      ))}
                    </FormControl>
                    <ErrorMessage component="span" name="unitCode" className="help-block" />
                  </FormGroup>
                </Col>
                <Col md={3} sm={6} xs={6}>
                  <FormGroup>
                    <Checkbox
                      inline
                      className="mt-checkbox mt-checkbox-outline"
                      name="taxable"
                      value={values.taxable}
                      checked={!!values.taxable}
                      disabled={this.isOnlineProduct()}
                      onChange={handleChange}
                    >
                      <span />
                    </Checkbox>
                    <ControlLabel>{t('Taxable')}</ControlLabel>
                  </FormGroup>
                </Col>
              </Row>
              {!this.isOnlineProduct() && (
                <Row>
                  <Col sm={12} className="text-right">
                    {!!this.state.error && <Alert bsStyle="danger">{this.state.error}</Alert>}
                    <Button onClick={onCancel}>{t('Cancel')}</Button>
                    {' '}
                    <LoadingButton
                      bsStyle="primary"
                      type="submit"
                      label={t('Save')}
                      loadingLabel={t('Save')}
                      isLoading={isSubmitting}
                    />
                  </Col>
                </Row>
              )}
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default withTranslation()(inject('mixStore', 'materialStore')(observer(ProductForm)));
